import ClipSelectHeader from './ClipSelectHeader';

export default ClipSelectHeader;
